module.exports = __webpack_public_path__ + "img/base_be_attacked_1.2c468c84.png";